export enum NexResponsePriceMode
{
    Phase1 = 'Phase1',
    Phase2 = 'Phase2',
}
